<script>
import {getSensorDataForMonth} from "@/api/mqtt";
import {formatDate} from "@/utils/data";
import {findDistanceSensor} from "@/api/sync";

export default {
  name: 'OilHistory',
  data(){
    return {
      visible : false,
      equipmentId : null,
      sensorId : 1453251191935201,
      dataList: [],
      monthDate: null,

    }
  },
  methods: {
    open(id) {
      this.visible = true
      this.equipmentId = id
      this.monthDate = new Date()
      this.queryMonth()
    },
    async queryMonth(){
      // 查询一次传感器
     const res = await findDistanceSensor(this.equipmentId);
     if (res && res.code === "0000" && res.result && res.result.length > 0){
       this.sensorId = res.result[0].id
        const param = {id: this.sensorId,monthDate : formatDate(this.monthDate) }
        const resp = await getSensorDataForMonth(param);
        if (resp && resp.code === "0000" && resp.result){
          this.dataList = resp.result || []
        }else {
          this.$message.error("传感器历史数据查询失败")
        }
     }else {
       this.$message.error("未查询到传感器数据")
     }


    }

  }
}


</script>

<template>
  <el-dialog :visible.sync="visible" title="历史读数" width="80vw" >
      <div style="display: flex; align-items: center; gap: 20px">
        <el-date-picker v-model="monthDate" type="month" placeholder="选择月份" />
        <el-button type="primary" @click="queryMonth" icon="el-icon-search" >查询</el-button>
      </div>
      <div style="height: 60vh; overflow: hidden; padding: 10px">
        <el-empty v-if="dataList.length === 0"   />
      </div>
  </el-dialog>
</template>

<style scoped>

</style>
